export { default as BannerWithLayoutHeader } from './hocs';
